import moment from 'jalali-moment';
import { Select, TextField } from '../widgets';
import { FilterType } from './Contracts';
import { UpdateFunc } from '../widgets/types';
import { Checkbox } from '../widgets/beauty/input';
import { fetchOptions } from './internal';
import DatePicker from 'react-datepicker2';

export interface ExportFilterProps {
  type: FilterType;
  name: string;
  label: string;
  value: any;
  disabled?: boolean;
  onChange?: (value: any) => void;
  fields?: string[];
  search?: string;
  searchMap?: { name: string; value: string; };
  hasConfclit?: boolean;
  defaultValue?: any;
}

export interface RenderOption extends ExportFilterProps {
  value: any;
  update: UpdateFunc;
}

const getDefaultValue = (type: string, value?: any) => {
  if (value === undefined) {
    switch (type) {
      case FilterType.Text: return '';
      case FilterType.Boolean: return false;
      case FilterType.Date: return moment();
      case FilterType.Select:
      case FilterType.SelectLong:
        return null;
    }
  }
  return value;
}

const renderTextField = ({ label, value, update, disabled }) => (
  <>
    <label>{label}</label>
    <TextField
      text={value}
      disabled={disabled}
      onTextChange={(e) => update(e.target.value)}
    />
  </>
);

const renderCheckbox = ({ label, value, disabled, update }) => (
  <Checkbox
    text={label}
    className="mt-auto"
    disabled={disabled}
    checked={Boolean(value)}
    onChange={(e) => update(!value)} />
);

const renderDate = ({ label, value, disabled, update }) => (
  <>
    <label>{label}</label>
    <DatePicker
      inputReadOnly
      value={value}
      onChange={update}
      isGregorian={false}
      className={'datepicker-input-cmp'}
      {...{ disabled } as any}
    />
  </>
);

const renderSelect = ({ label, value, fields, disabled, search, searchMap, update }) => {
  const options = [
    { name: `انتخاب ${label}`, value: null },
    ...(fields ?? []).map(x => ({ name: x, value: x }))
  ];
  return (
    <>
      <label htmlFor="select-db">{label}</label>
      <Select
        options={options}
        getOptions={() => fetchOptions(label, search, searchMap, options)}
        value={value}
        onChange={update}
        disabled={disabled} />
    </>
  );
}

const renderFilter = (options: RenderOption) => {
  const { type, label, value, fields, disabled, search, searchMap, update } = options;

  switch (type) {
    case FilterType.Text: return renderTextField({ label, value, disabled, update });
    case FilterType.Boolean: return renderCheckbox({ label, value, disabled, update });
    case FilterType.Select: return renderSelect({ label, value, fields, disabled, search, searchMap, update });
    case FilterType.Date: return renderDate({ label, value, disabled, update });
  }
  return '';
}

const ExportFilter = (props: ExportFilterProps) => {
  let { value } = props;
  if (value === undefined) {
    value = getDefaultValue(props.type, props.defaultValue)
  }
  return (
    <li className="col-xxl-3 export-filter-item">
      {renderFilter({
        ...props,
        value,
        update: (value) => props.onChange(value)
      })}
    </li>
  );
}

export default ExportFilter;
